import { FC, Key, PropsWithChildren } from 'react';

import classNames from 'classnames';
import { IonItem, IonRadio } from '@ionic/react';

import { FormRadioGroupItemInset } from './FormRadioGroupItem.types';

import group from '../../_styles/group.module.scss';

type FormRadioGroupItemProps = PropsWithChildren<{
  value: Key;
  className?: string;
  inset?: FormRadioGroupItemInset;
  disabled?: boolean;
}>;

export const FormRadioGroupItem: FC<FormRadioGroupItemProps> = ({
  value,
  children,
  inset = 'md',
  disabled,
}) => {
  return (
    <IonItem lines="full" className={classNames(group.item, group[inset])}>
      <IonRadio
        value={value}
        justify="start"
        disabled={disabled}
        labelPlacement="end"
        className={group.control}
      >
        <div className={classNames(group.content)}>{children}&nbsp;</div>
      </IonRadio>
    </IonItem>
  );
};
